/**
 * Public book URL helper — prefer SEO slug when available.
 */
export function bookSlugFrom(book) {
  if (!book) return '';
  if (typeof book === 'string') return book;
  return (
    book.slug ||
    book.fields?.slug ||
    book.id ||
    book.airtable_id ||
    ''
  );
}

export function bookPath(book) {
  const slug = bookSlugFrom(book);
  return slug ? `/books/${slug}` : '/books';
}

export function looksLikeBookRecordId(value) {
  const v = String(value || '').replace(/^book_/, '');
  return /^rec[a-zA-Z0-9]{10,}$/.test(v);
}

/** Turkish-aware slugify (mirrors backend slug_utils.slugify_tr). */
export function slugifyTr(text, fallback = 'kitap') {
  const map = {
    Ç: 'c', Ğ: 'g', İ: 'i', Ö: 'o', Ş: 's', Ü: 'u',
    ç: 'c', ğ: 'g', ı: 'i', ö: 'o', ş: 's', ü: 'u', I: 'i',
    Â: 'a', â: 'a', Ê: 'e', ê: 'e', Î: 'i', î: 'i',
    Ô: 'o', ô: 'o', Û: 'u', û: 'u',
  };
  let s = String(text || '');
  s = s.replace(/[ÇĞİÖŞÜçğıöşüIÂâÊêÎîÔôÛû]/g, (ch) => map[ch] || ch);
  // Strip other combining marks (é → e)
  try {
    s = s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  } catch (_) {
    /* older browsers */
  }
  s = s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  return s || fallback;
}

